import * as React from 'react'

import OptionsCheckItem from '~/client/src/shared/components/OptionsList/pieces/OptionsCheckItem'
import OptionsEmpty from '~/client/src/shared/components/OptionsList/pieces/OptionsEmpty'
import OptionsItemList from '~/client/src/shared/components/OptionsList/pieces/OptionsItemList'
import OptionsListHeader from '~/client/src/shared/components/OptionsList/pieces/OptionsListHeader'
import OptionsSeparator from '~/client/src/shared/components/OptionsList/pieces/OptionsSeparator'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { useDrillDownFilterContext } from '../context'
import { ResetButton } from '../DrillDownFilterPieces'
import { filterDrillDownCategoryItems } from '../filterCategories'

export default function FlatItemList({
  resetSize,
}: {
  resetSize?: 'sm' | 'default' | 'lg'
}) {
  const { state, actions, meta } = useDrillDownFilterContext()
  const category = meta.selectedCategory
  if (!category) return null

  const items = filterDrillDownCategoryItems(category, state.searchTerm)

  if (items.length === 0) {
    return (
      <OptionsItemList>
        <OptionsEmpty />
      </OptionsItemList>
    )
  }

  const selectedCount = items.filter(item =>
    state.pendingSelection.has(category.getItemId(item)),
  ).length
  const isAllSelected = selectedCount === items.length
  const isPartiallySelected = selectedCount > 0 && selectedCount < items.length

  const toggleAll = () =>
    actions.onToggleItems(
      items.map(item => category.getItemId(item)),
      !isAllSelected,
    )

  return (
    <>
      <OptionsListHeader
        checked={isAllSelected}
        indeterminate={isPartiallySelected}
        onToggle={toggleAll}
        label={`${items.length} ${category.label} / ${selectedCount} ${Localization.translator.selected}`}
        action={
          state.pendingSelection.size > 0 ? (
            <ResetButton onClick={actions.onClearAll} size={resetSize} />
          ) : undefined
        }
      />
      <OptionsSeparator />
      <OptionsItemList>
        {items.map(item => {
          const itemId = category.getItemId(item)
          const isSelected = state.pendingSelection.has(itemId)
          const label = category.getItemLabel(item)
          const content = category.renderItem
            ? category.renderItem(item, isSelected, label)
            : label
          return (
            <OptionsCheckItem
              key={itemId}
              checked={isSelected}
              onClick={() => actions.onToggleItem(itemId)}
            >
              {content}
            </OptionsCheckItem>
          )
        })}
      </OptionsItemList>
    </>
  )
}
